<template>
    <div class="vista-previa" :style="estiloRaiz">
        <div class="vista-previa__titulo">Vista previa en vivo</div>

        <!-- Cabecera del sistema -->
        <div class="vp-cabecera" :style="{background: colores.primario}">
            <span class="vp-cabecera__menu"></span>
            <img :src="logos.gobierno || logosPredeterminados.gobierno" alt="Logo del Gobierno" class="vp-cabecera__logo">
            <span class="vp-cabecera__texto">Sistema de Certificación</span>
            <span class="vp-cabecera__avatar" :style="{background: colores.acento}"></span>
        </div>

        <!-- Contenido con un botón -->
        <div class="vp-contenido" :style="{background: colores.fondo, color: colores.texto}">
            <div class="vp-contenido__tarjeta">
                <div class="vp-contenido__encabezado" :style="{color: colores.primario}">Mis cursos</div>
                <div class="vp-contenido__linea" :style="{background: colores.secundario}"></div>
                <p class="vp-contenido__parrafo">Así se verán los textos del sistema con la fuente <b>{{ fuente.familia }}</b>.</p>
                <button type="button" class="vp-boton" :style="{background: colores.primario, color: contraste(colores.primario)}">Descargar certificado</button>
                <button type="button" class="vp-boton vp-boton--borde" :style="{borderColor: colores.acento, color: colores.acento}">Ver detalle</button>
            </div>
        </div>

        <!-- Panel de acceso -->
        <div class="vp-acceso">
            <div class="vp-acceso__hero" :style="{background: `linear-gradient(160deg, ${colores.primario} 0%, ${oscurecer(colores.primario, 0.35)} 100%)`}">
                <span class="vp-acceso__placa"><img :src="logos.infop || logosPredeterminados.infop" alt="Logo INFOP"></span>
                <span class="vp-acceso__eyebrow" :style="{color: colores.acento}">INFOP</span>
                <span class="vp-acceso__frase">Tus certificados, verificados y a la mano.</span>
            </div>
            <div class="vp-acceso__tarjeta" :style="{borderTopColor: colores.acento, color: colores.texto}">
                <img :src="logos.gobierno || logosPredeterminados.gobierno" alt="Logo del Gobierno" class="vp-acceso__gobierno">
                <span class="vp-acceso__eyebrow" :style="{color: colores.acento}">Acceso</span>
                <span class="vp-acceso__titulo" :style="{color: colores.primario}">Consulta tus certificados</span>
                <span class="vp-acceso__campo"></span>
                <span class="vp-acceso__campo"></span>
                <button type="button" class="vp-boton vp-boton--ancho" :style="{background: colores.acento, color: contraste(colores.acento)}">Ingresar</button>
            </div>
        </div>

        <div class="vista-previa__favicon" v-if="logos.favicon">
            <img :src="logos.favicon" alt="Favicon">
            <span>Favicon en la pestaña del navegador</span>
        </div>
    </div>
</template>

<script>
/**
 * Simulación en miniatura de la cabecera del sistema, un contenido con botones
 * y el panel de acceso, pintados con los colores, la fuente y los logos que se
 * estén editando. No depende del tema aplicado a la aplicación.
 */
import {logosPredeterminados, pilaFuente} from "@/services/apariencia";

export default {
    name: "TemaVistaPrevia",
    props: {
        colores: {type: Object, required: true},
        fuente: {type: Object, required: true},
        logos: {type: Object, default: () => ({gobierno: null, infop: null, favicon: null})},
    },
    data() {
        return {logosPredeterminados};
    },
    computed: {
        estiloRaiz() {
            return {fontFamily: pilaFuente(this.fuente)};
        },
    },
    methods: {
        rgb(hex) {
            const limpio = String(hex || "#000000").replace("#", "");
            const completo = limpio.length === 3 ? limpio.split("").map(c => c + c).join("") : limpio;
            const n = parseInt(completo, 16);
            return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
        },
        /** Blanco o tinta oscura según la luminancia del fondo. */
        contraste(hex) {
            const [r, g, b] = this.rgb(hex);
            const luminancia = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
            return luminancia > 0.62 ? "#1B2340" : "#FFFFFF";
        },
        oscurecer(hex, factor) {
            const [r, g, b] = this.rgb(hex).map(c => Math.round(c * (1 - factor)));
            return `rgb(${r}, ${g}, ${b})`;
        },
    },
}
</script>

<style scoped lang="scss">
.vista-previa {
    border: 1px solid #DCE1EC;
    border-radius: 12px;
    overflow: hidden;
    background: #fff;
    font-size: 12px;
    line-height: 1.4;
}

.vista-previa__titulo {
    padding: 8px 12px;
    font-size: 11px;
    letter-spacing: .08em;
    text-transform: uppercase;
    color: #5B6480;
    background: #F3F5FA;
    border-bottom: 1px solid #DCE1EC;
}

.vp-cabecera {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 12px;
    color: #fff;

    &__menu {
        width: 16px;
        height: 2px;
        background: currentColor;
        box-shadow: 0 5px 0 currentColor, 0 -5px 0 currentColor;
        margin: 0 4px;
    }

    &__logo {
        height: 22px;
        width: auto;
        background: #fff;
        border-radius: 4px;
        padding: 2px 4px;
    }

    &__texto {
        flex: 1;
        font-weight: 600;
        font-size: 13px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    &__avatar {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        border: 2px solid rgba(#fff, .7);
    }
}

.vp-contenido {
    padding: 12px;

    &__tarjeta {
        background: #fff;
        border-radius: 10px;
        padding: 12px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, .08);
    }

    &__encabezado {
        font-weight: 700;
        font-size: 14px;
    }

    &__linea {
        width: 44px;
        height: 3px;
        border-radius: 2px;
        margin: 6px 0 8px;
    }

    &__parrafo {
        margin: 0 0 10px;
    }
}

.vp-boton {
    border: 0;
    border-radius: 8px;
    padding: 7px 12px;
    font: inherit;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: .04em;
    cursor: default;
    margin-right: 8px;

    &--borde {
        background: transparent;
        border: 1.5px solid;
    }

    &--ancho {
        width: 100%;
        margin: 8px 0 0;
    }
}

.vp-acceso {
    display: grid;
    grid-template-columns: 1fr 1fr;
    border-top: 1px solid #DCE1EC;

    &__hero {
        padding: 14px;
        color: #fff;
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    &__placa {
        width: 34px;
        height: 34px;
        border-radius: 9px;
        background: #fff;
        display: grid;
        place-items: center;

        img {
            width: 24px;
            height: auto;
        }
    }

    &__eyebrow {
        font-size: 10px;
        letter-spacing: .12em;
        text-transform: uppercase;
        font-weight: 600;
    }

    &__frase {
        font-weight: 700;
        font-size: 13px;
        line-height: 1.25;
    }

    &__tarjeta {
        padding: 14px;
        background: #fff;
        border-top: 3px solid;
        display: flex;
        flex-direction: column;
        gap: 6px;
    }

    &__gobierno {
        width: 100%;
        max-width: 150px;
        height: auto;
        margin: 0 auto 4px;
    }

    &__titulo {
        font-weight: 700;
        font-size: 13px;
    }

    &__campo {
        height: 20px;
        border: 1px solid #DCE1EC;
        border-radius: 6px;
    }
}

.vista-previa__favicon {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 12px;
    border-top: 1px solid #DCE1EC;
    color: #5B6480;

    img {
        width: 16px;
        height: 16px;
        object-fit: contain;
    }
}
</style>
